<template>
  <v-container class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Transction Hold</div>
        <div>
          <bread-crumb :bread-crumbs="['Hold Transactions']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="">
        <v-card-text class="mb-3">
          <v-form>
            <v-row class="mt-2">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="from_date"
                  label="From Date"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="to_date"
                  type="date"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12" class="d-flex">
                <v-btn
                  depressed
                  class="primary text-capitalize"
                  @click="getHoldTransactions()"
                  small
                  >Get Results</v-btn
                >
                <v-btn
                  depressed
                  class="mx-2 primary text-capitalize"
                  small
                  @click="clear()"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>

          <v-row>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="mt-2 ms-1"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter values."
              hide-details
              dense
              single-line
              clearable
              class="mt-2"
            ></v-text-field
          ></v-row>
        </v-card-text>

        <v-data-table
          :loading="loader"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="holdTxnlist"
          class=""
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              depressed
              outlined
              small
              color="green"
              class="text-capitalize"
              @click="openPopup(item)"
              >Release<v-icon x-small class="ms-2"
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </template>
          <template v-slot:item.txn_status="{ item }">
            <v-chip rounded small color="primary" block outlined>
              {{ item.txn_status }}
            </v-chip>
          </template>
          <template v-slot:item.payment_id="{ item }">
            <a class="border-d" @click="viewTxn(item)">{{ item.payment_id }}</a>
          </template>
          <template v-slot:item.bank_receipt="{ item }">
            <v-img
              v-if="item.bank_receipt"
              class="ml-1"
              max-height="40"
              max-width="50"
              :src="item.bank_receipt"
              @click="handleImageViewer(item.bank_receipt, '')"
            />
          </template>
        </v-data-table>
      </div>
      <v-dialog persistent v-model="showPopup" max-width="500px">
        <OverlayPageVue :showOverlay="loader" />
        <v-card>
          <v-toolbar class="ma-0 pa-0" color="secondary" dark flat dense>
            <span>Release Transaction</span>
            <!-- <v-spacer></v-spacer> -->
            <v-spacer></v-spacer>
            <v-icon small @click="closePopup">mdi-close</v-icon>
          </v-toolbar>
          <v-form>
            <!-- <v-divider class="ma-0 pa-0"></v-divider> -->
            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="releaseForm">
                <v-row>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Status </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Status"
                      :items="status_items"
                      :rules="FieldRequired('Status')"
                      v-model="selectedStatus"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="my-0"
                    ><label
                      :class="
                        selectedStatus === 'Approve'
                          ? 'my-0 labelFontsize'
                          : 'my-0 labelFontsize required'
                      "
                      >Remarks</label
                    >
                    <v-textarea
                      class="rounded"
                      dense
                      outlined
                      :rules="
                        selectedStatus != 'Approve'
                          ? FieldRequired('Remarks')
                          : []
                      "
                      placeholder="Remarks"
                      v-model="remarks"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-form>
          <v-divider class="mb-0"></v-divider>
          <v-card-actions class="justify-end">
            <v-btn
              depressed
              color="primary"
              class="text-capitalize"
              small
              @click="updateTxnStatus()"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import imageViewer from "@/components/tools/imageViewer.vue";
import { FieldRequired } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import agentService from "@/services/agentService/AgentService.js";
export default {
  name: "Hold Transactions",
  mixins: [alerts],
  data() {
    return {
      FieldRequired,
      showPopup: false,
      imageViewerUrl: null,
      isImageViewer: false,
      showRemarksField: false,
      selectedReleaseItem: null,
      remarks: "",
      valid: false,
      selectedTxn: null,
      search: "",
      selectedStatus: "",
      headers: [
        { text: "PIN No", value: "payment_id", sortable: false },
        { text: "TXN date", value: "txn_date", sortable: false },
        { text: "TXN status", value: "txn_status", sortable: false },
        { text: "Payment mode", value: "payment_mode", sortable: false },
        { text: "Sender name", value: "sender_name", sortable: false },
        {
          text: "Payout country",
          value: "receiver_country",
          sortable: false,
        },
        { text: "Beneficiary name", value: "receiver_name", sortable: false },
        {
          text: "Receiving agent",
          value: "receiving_partner",
          sortable: false,
        },

        { text: "Receiving amount", value: "amount", sortable: false },
        { text: "Remarks", value: "remarks", sortable: false },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
        },
      ],
      holdTxnlist: [],
      release_items: [],
      status_items: ["Approve", "Hold", "Reject"],
      loader: false,
      from_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),
    };
  },
  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },
  mounted() {
    this.getHoldTransactions();
  },
  watch: {},
  methods: {
    async downloadExcelsheet() {
      if (this.holdTxnlist) {
        this.exportToExcel(this.headers, this.holdTxnlist, "holdTxn_list");
      }
    },
    viewTxn(item) {
      this.$router.push({
        name: "Hold Details",
        query: { id: item.id, login_id: item.login_id, from: "hold" },
      });
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url, val) {
      if (val === "showImage") {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      } else {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      }
    },
    Imageview(file) {
      const imageurl = URL.createObjectURL(file);
      this.suspectFileUrl = imageurl;
    },

    async updateTxnStatus() {
      const validate = this.$refs.releaseForm.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await agentService.updateHoldtxn({
            transaction_id: this.selectedTxn.id,
            approval_status: this.selectedStatus,
            remarks: this.remarks ? this.remarks : "",
          });
          if (responseData && responseData.data.status_code === 200) {
            this.getHoldTransactions();
            this.loader = false;
            this.$refs.releaseForm.reset();
            this.showPopup = false;
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.loader = false;
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    async getHoldTransactions() {
      this.loader = true;
      try {
        const responseData = await agentService.getHoldTxnByDate({
          from_date: this.from_date,
          to_date: this.to_date,
          transaction_status: "02",
          transaction_stage: "02",
        });
        this.loader = false;
        if (responseData && responseData.data.status_code === 200) {
          this.holdTxnlist = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("getdata", responseData.data.status_code);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    openPopup(item) {
      console.log(item);
      this.selectedTxn = item;
      this.selectedReleaseItem = null;
      this.remarks = item.remarks;
      this.showPopup = true;
    },
    closePopup() {
      // Close the popup
      this.showPopup = false;
      this.selectedReleaseItem = null;
      this.remarks = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.required:after {
  content: " *";
  color: red;
}
</style>
